// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
}
@media (max-width: 768px) {
  .invoice-form-container {
    padding: 1rem;
  }
}
.invoice-form-container .no-spinner::-webkit-outer-spin-button,
.invoice-form-container .no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.invoice-form-container .invoice-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: invoice-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .invoice-form-container .invoice-form-wrapper {
    padding: 1rem;
    width: 95%;
  }
}
.invoice-form-container .invoice-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.invoice-form-container .invoice-form-header {
  position: relative;
  text-align: center;
  margin-bottom: 0.5rem;
}
.invoice-form-container .invoice-form-header .invoice-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .invoice-form-container .invoice-form-header .invoice-form-title {
    font-size: 1.25rem;
  }
}
.invoice-form-container .invoice-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.invoice-form-container .invoice-form-content {
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
}
.invoice-form-container .form-section {
  background: transparent;
  border-radius: 0.375rem;
  margin-bottom: 1.5rem;
}
.invoice-form-container .form-section:last-of-type {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .invoice-form-container .form-section {
    padding: 1rem;
  }
}
.invoice-form-container .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.invoice-form-container .form-section h3 .invoice-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.invoice-form-container .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.invoice-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .invoice-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.invoice-form-container .form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.invoice-form-container .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.invoice-form-container .form-group label .invoice-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.invoice-form-container .form-group input,
.invoice-form-container .form-group select,
.invoice-form-container .form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.invoice-form-container .form-group input:focus,
.invoice-form-container .form-group select:focus,
.invoice-form-container .form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.invoice-form-container .form-group input:hover:not(:focus),
.invoice-form-container .form-group select:hover:not(:focus),
.invoice-form-container .form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.invoice-form-container .form-group input::placeholder,
.invoice-form-container .form-group select::placeholder,
.invoice-form-container .form-group textarea::placeholder {
  color: #9ca3af;
}
.invoice-form-container .form-group input:disabled,
.invoice-form-container .form-group select:disabled,
.invoice-form-container .form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.invoice-form-container .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.invoice-form-container .form-group textarea {
  height: auto;
  min-height: 4rem;
  resize: vertical;
  line-height: 1.5;
}
.invoice-form-container .form-group .amount-display {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  font-weight: 600;
  color: #059669;
  background: #ecfdf5;
  border: 1px solid #d1fae5;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  min-width: 100px;
}
.invoice-form-container .added-services-container {
  margin-bottom: 1.5rem;
}
.invoice-form-container .added-services-container .service-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 1rem;
  transition: all 0.2s ease;
}
.invoice-form-container .added-services-container .service-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.invoice-form-container .added-services-container .service-card .service-card-content {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 768px) {
  .invoice-form-container .added-services-container .service-card .service-card-content {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
}
.invoice-form-container .added-services-container .service-card .service-card-main {
  display: flex;
  flex: 1 1;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 768px) {
  .invoice-form-container .added-services-container .service-card .service-card-main {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
}
.invoice-form-container .added-services-container .service-card .service-info {
  flex: 1 1;
}
.invoice-form-container .added-services-container .service-card .service-info h4 {
  margin: 0 0 0.25rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}
.invoice-form-container .added-services-container .service-card .service-info .service-description {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
  font-style: italic;
}
.invoice-form-container .added-services-container .service-card .service-details {
  display: flex;
  gap: 1rem;
  align-items: center;
  font-size: 0.875rem;
  color: #4b5563;
}
@media (max-width: 768px) {
  .invoice-form-container .added-services-container .service-card .service-details {
    justify-content: space-between;
  }
}
.invoice-form-container .added-services-container .service-card .service-details .service-amount {
  font-weight: 600;
  color: #059669;
  font-size: 1rem;
}
.invoice-form-container .added-services-container .service-card .service-card-actions {
  display: flex;
  gap: 0.5rem;
  margin-left: 1rem;
}
@media (max-width: 768px) {
  .invoice-form-container .added-services-container .service-card .service-card-actions {
    margin-left: 0;
    justify-content: center;
  }
}
.invoice-form-container .added-services-container .service-card .service-card-actions .edit-service-btn {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .edit-service-btn:hover:not(:disabled) {
  background-color: #2563eb;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .edit-service-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .delete-service-btn {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .delete-service-btn:hover:not(:disabled) {
  background-color: #dc2626;
}
.invoice-form-container .added-services-container .service-card .service-card-actions .delete-service-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
.invoice-form-container .current-service-form {
  background: #ffffff;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
}
.invoice-form-container .current-service-form .service-form-header {
  margin-bottom: 1rem;
}
.invoice-form-container .current-service-form .service-form-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
}
.invoice-form-container .current-service-form .service-form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .invoice-form-container .current-service-form .service-form-row {
    flex-direction: column;
    gap: 0.75rem;
  }
}
.invoice-form-container .current-service-form .service-description-row {
  margin-bottom: 1rem;
}
.invoice-form-container .current-service-form .service-description-row .description-group {
  flex: 1 1;
}
.invoice-form-container .current-service-form .service-form-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .invoice-form-container .current-service-form .service-form-actions {
    flex-direction: column;
  }
}
.invoice-form-container .current-service-form .service-form-actions .add-current-service-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.invoice-form-container .current-service-form .service-form-actions .add-current-service-btn:hover:not(:disabled) {
  background-color: #2563eb;
}
.invoice-form-container .current-service-form .service-form-actions .add-current-service-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.invoice-form-container .current-service-form .service-form-actions .cancel-edit-btn {
  background-color: #6b7280;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.invoice-form-container .current-service-form .service-form-actions .cancel-edit-btn:hover {
  background-color: #4b5563;
}
.invoice-form-container .summary {
  background: var(--grey-shade-three);
  padding: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #e5e7eb;
  margin: 1rem 0 0 0;
}
.invoice-form-container .summary p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem 0;
  font-size: 0.875rem;
  color: #374151;
}
.invoice-form-container .summary p:first-child {
  margin-top: 0;
}
.invoice-form-container .summary p:last-child {
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #059669;
  border-top: 1px solid #e5e7eb;
  padding-top: 0.75rem;
  margin-top: 0.75rem;
}
.invoice-form-container .summary p strong {
  color: #111827;
  font-weight: 500;
}
.invoice-form-container .summary p span {
  font-size: 0.75rem;
  color: #6b7280;
  font-style: italic;
}
.invoice-form-container .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .invoice-form-container .form-actions {
    flex-direction: column;
  }
}
.invoice-form-container .form-actions .btn-primary {
  padding: 0.75rem 1.5rem;
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  border: none;
  min-width: 120px;
  transition: all 0.2s ease;
  background-color: var(--primary-color);
  color: white;
}
@media (max-width: 768px) {
  .invoice-form-container .form-actions .btn-primary {
    width: 100%;
  }
}
.invoice-form-container .form-actions .btn-primary:hover:not(:disabled) {
  background-color: #005a9a;
}
.invoice-form-container .form-actions .btn-primary:focus {
  outline: none;
}
.invoice-form-container .form-actions .btn-primary:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  opacity: 0.6;
  cursor: not-allowed;
}
.invoice-form-container .client-modal-header-inv .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
}
.invoice-form-container .client-modal-header-inv .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}
.invoice-form-container .service-modal-body h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  text-align: center;
}
.invoice-form-container .service-modal-body .new-service-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
}
.invoice-form-container .service-modal-body .new-service-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.invoice-form-container .service-modal-body .btn-primary {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transform: translateX(10.7rem);
}
.invoice-form-container .service-modal-body .btn-primary:hover {
  background-color: #005a9a;
}
.invoice-form-container .service-modal-body .btn-primary:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
.invoice-form-container input:focus-visible,
.invoice-form-container select:focus-visible,
.invoice-form-container textarea:focus-visible,
.invoice-form-container button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

@keyframes invoice-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1024px) {
  .invoice-form-container .invoice-form-wrapper {
    width: 85%;
  }
  .invoice-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
@media (max-width: 768px) {
  .invoice-form-container {
    padding: 1rem;
  }
  .invoice-form-container .invoice-form-wrapper {
    width: 95%;
  }
  .invoice-form-container .form-section {
    padding: 1rem;
  }
  .invoice-form-container .invoice-form-header .invoice-form-title {
    font-size: 1.25rem;
  }
  .invoice-form-container .form-section h3 {
    font-size: 1rem;
  }
  .invoice-form-container .form-actions .btn-primary {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media (max-width: 480px) {
  .invoice-form-container {
    padding: 0.5rem;
  }
  .invoice-form-container .invoice-form-wrapper {
    padding: 0.75rem;
    width: 100%;
  }
  .invoice-form-container .form-section {
    padding: 0.75rem;
  }
  .invoice-form-container .invoice-form-header .invoice-form-title {
    font-size: 1.125rem;
  }
  .invoice-form-container .form-group input,
  .invoice-form-container .form-group select,
  .invoice-form-container .form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .invoice-form-container .form-group .amount-display {
    font-size: 0.8125rem;
    padding: 0.375rem;
  }
}
@media print {
  .invoice-form-container {
    background: white;
    padding: 0;
  }
  .invoice-form-container .invoice-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .invoice-form-container .form-section {
    box-shadow: none;
    border: 1px solid #000;
    page-break-inside: avoid;
  }
  .invoice-form-container .form-actions,
  .invoice-form-container .service-card-actions,
  .invoice-form-container .service-form-actions {
    display: none;
  }
}
.case-loading-text,
.no-cases-text {
  color: #6b7280;
  font-size: 0.875rem;
  font-style: italic;
  padding: 1rem;
  text-align: center;
  background: #f9fafb;
  border-radius: 0.375rem;
  border: 1px dashed #d1d5db;
}

.invoice-case-selector {
  position: relative;
}
.invoice-case-selector .invoice-label-case {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.invoice-case-selector .invoice-case-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.invoice-case-selector .invoice-case-dropdown-input:focus {
  outline: none;
  border-color: var(--primary-light-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.invoice-case-selector .invoice-case-dropdown-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.invoice-case-selector .invoice-case-dropdown-input::placeholder {
  color: #9ca3af;
}
.invoice-case-selector .clear-case-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 1;
}
.invoice-case-selector .clear-case-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.invoice-case-selector .invoice-dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: invoice-dropdown-fade-in 0.2s ease-out;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-tabs button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-tabs button.active {
  color: var(--primary-color);
  border-bottom-color: var(--primary-color);
  background-color: #ffffff;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option:last-child {
  border-bottom: none;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option:hover {
  background-color: #f9fafb;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option.selected {
  background-color: #eff6ff;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option.selected:hover {
  background-color: #dbeafe;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option .invoice-case-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option .invoice-case-info .invoice-case-parties {
  font-weight: 600;
  font-size: 0.875rem;
  color: #1f2937;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option .invoice-case-info .invoice-case-ref {
  font-size: 0.75rem;
  color: #6b7280;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-dropdown-option .invoice-case-info .invoice-case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options .invoice-no-data {
  padding: 1rem;
  text-align: center;
  color: #6b7280;
  font-size: 0.875rem;
  font-style: italic;
}

.invoice-selected-case-display {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.75rem;
  padding: 0.75rem 1rem;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 0.375rem;
}
.invoice-selected-case-display .invoice-selected-case-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}
.invoice-selected-case-display .invoice-selected-case-value {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: #1f2937;
}
.invoice-selected-case-display .invoice-selected-case-value .invoice-court-type-badge {
  font-size: 0.75rem;
  font-weight: 500;
  color: #ffffff;
  background: var(--primary-color);
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
}
.invoice-selected-case-display .invoice-clear-case-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.25rem;
  color: #9ca3af;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.15s ease;
}
.invoice-selected-case-display .invoice-clear-case-btn:hover {
  color: #ef4444;
  background: #fef2f2;
}

@keyframes invoice-dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* MODIFICATION: ADDED STYLES FOR THE NEW "ADD SERVICE" MODAL */
.confirmation-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Higher z-index for modals */
  padding: 20px;
  box-sizing: border-box;
}

.confirmation-modal {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  max-width: 95%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #e5e7eb;
  position: relative;
  animation: invoice-form-fade-in 0.2s ease-out; /* Re-using existing animation */
}
.confirmation-modal.notinvoice {
  width: 420px; /* Specific width for the small modal */
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.confirmation-actions.notinvoice {
  padding-top: 0;
}
.confirmation-actions .confirm-btn,
.confirmation-actions .cancel-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.confirmation-actions .confirm-btn:disabled,
.confirmation-actions .cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.confirmation-actions .confirm-btn {
  background: var(--primary-color);
  color: white;
}
.confirmation-actions .confirm-btn:hover:not(:disabled) {
  filter: brightness(95%);
}
.confirmation-actions .confirm-btn:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.confirmation-actions .cancel-btn {
  background: #6b7280;
  color: white;
}
.confirmation-actions .cancel-btn:hover:not(:disabled) {
  background: #4b5563;
}

.add-new-field-modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.add-new-field-modal-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  text-align: left;
  border-bottom: none;
  padding-bottom: 0;
}
.add-new-field-modal-content .add-new-field-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}
.add-new-field-modal-content .add-new-field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.confirmation-modal .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  position: absolute;
  top: 12px;
  right: 12px;
}
.confirmation-modal .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}`, "",{"version":3,"sources":["webpack://./src/forms/InvoiceForm/InvoiceForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EAXF;IAYI,aAAA;EACF;AACF;AAEE;;EAEE,wBAAA;EACA,SAAA;AAAJ;AAIE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,6CAAA;EACA,UAAA;AAFJ;AAII;EATF;IAUI,aAAA;IACA,UAAA;EADJ;AACF;AAKE;EACE,cAAA;EACA,oBAAA;AAHJ;AAOE;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AALJ;AAOI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AALN;AAOM;EANF;IAOI,kBAAA;EAJN;AACF;AASE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAPJ;AAWE;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;AATJ;AAaE;EACE,uBAAA;EACA,uBAAA;EACA,qBAAA;AAXJ;AAaI;EACE,gBAAA;AAXN;AAcI;EATF;IAUI,aAAA;EAXJ;AACF;AAaI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAXN;AAaM;EACE,cAAA;EACA,oBAAA;AAXR;AAiBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,gBAAA;AAfN;AAkBI;EATF;IAUI,sBAAA;IACA,WAAA;EAfJ;AACF;AAkBE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAhBJ;AAkBI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAhBN;AAkBM;EACE,cAAA;EACA,oBAAA;AAhBR;AAqBI;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAnBN;AAqBM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjBR;AAoBM;;;EACE,qBAAA;AAhBR;AAmBM;;;EACE,cAAA;AAfR;AAkBM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAdR;AAkBI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAhBN;AAmBI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAjBN;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAnBN;AAwBE;EACE,qBAAA;AAtBJ;AAwBI;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAtBN;AAwBM;EACE,qBAAA;EACA,yCAAA;AAtBR;AAyBM;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAvBR;AAyBQ;EANF;IAOI,sBAAA;IACA,oBAAA;IACA,SAAA;EAtBR;AACF;AAyBM;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;AAvBR;AAyBQ;EANF;IAOI,sBAAA;IACA,oBAAA;IACA,YAAA;EAtBR;AACF;AAyBM;EACE,SAAA;AAvBR;AAyBQ;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvBV;AA0BQ;EACE,SAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAxBV;AA4BM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AA1BR;AA4BQ;EAPF;IAQI,8BAAA;EAzBR;AACF;AA2BQ;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAzBV;AA6BM;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AA3BR;AA6BQ;EALF;IAMI,cAAA;IACA,uBAAA;EA1BR;AACF;AA4BQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AA1BV;AA4BU;EACE,yBAAA;AA1BZ;AA6BU;EACE,yBAAA;EACA,mBAAA;AA3BZ;AA+BQ;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AA7BV;AA+BU;EACE,yBAAA;AA7BZ;AAgCU;EACE,yBAAA;EACA,mBAAA;AA9BZ;AAsCE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AApCJ;AAsCI;EACE,mBAAA;AApCN;AAsCM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApCR;AAwCI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAtCN;AAwCM;EALF;IAMI,sBAAA;IACA,YAAA;EArCN;AACF;AAwCI;EACE,mBAAA;AAtCN;AAwCM;EACE,SAAA;AAtCR;AA0CI;EACE,aAAA;EACA,YAAA;EACA,yBAAA;AAxCN;AA0CM;EALF;IAMI,sBAAA;EAvCN;AACF;AAyCM;EACE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AAvCR;AAyCQ;EACE,yBAAA;AAvCV;AA0CQ;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAxCV;AA4CM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AA1CR;AA4CQ;EACE,yBAAA;AA1CV;AAiDE;EACE,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AA/CJ;AAiDI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA/CN;AAiDM;EACE,aAAA;AA/CR;AAkDM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;AAhDR;AAmDM;EACE,cAAA;EACA,gBAAA;AAjDR;AAoDM;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAlDR;AAwDE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AAtDJ;AAwDI;EARF;IASI,sBAAA;EArDJ;AACF;AAuDI;EACE,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,sCAAA;EACA,YAAA;AArDN;AAuDM;EAZF;IAaI,WAAA;EApDN;AACF;AAsDM;EACE,yBAAA;AApDR;AAuDM;EACE,aAAA;AArDR;AAwDM;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AAtDR;AA6DI;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA3DN;AA6DM;EACE,cAAA;EACA,yBAAA;AA3DR;AAiEI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AA/DN;AAkEI;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AAhEN;AAkEM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhER;AAoEI;EACE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AAlEN;AAoEM;EACE,yBAAA;AAlER;AAqEM;EACE,yBAAA;EACA,mBAAA;AAnER;AAyEE;;;;EAIE,0BAAA;EACA,mBAAA;AAvEJ;;AA4EA;EACE;IACE,UAAA;IACA,2BAAA;EAzEF;EA2EA;IACE,UAAA;IACA,wBAAA;EAzEF;AACF;AA6EA;EAEI;IACE,UAAA;EA5EJ;EA+EE;IACE,sBAAA;IACA,WAAA;EA7EJ;AACF;AAiFA;EACE;IACE,aAAA;EA/EF;EAiFE;IACE,UAAA;EA/EJ;EAkFE;IACE,aAAA;EAhFJ;EAmFE;IACE,kBAAA;EAjFJ;EAoFE;IACE,eAAA;EAlFJ;EAsFI;IACE,oBAAA;IACA,oBAAA;EApFN;AACF;AAyFA;EACE;IACE,eAAA;EAvFF;EAyFE;IACE,gBAAA;IACA,WAAA;EAvFJ;EA0FE;IACE,gBAAA;EAxFJ;EA2FE;IACE,mBAAA;EAzFJ;EA6FI;;;IAGE,iBAAA;IACA,oBAAA;EA3FN;EA8FI;IACE,oBAAA;IACA,iBAAA;EA5FN;AACF;AAkGA;EACE;IACE,iBAAA;IACA,UAAA;EAhGF;EAkGE;IACE,gBAAA;IACA,sBAAA;EAhGJ;EAmGE;IACE,gBAAA;IACA,sBAAA;IACA,wBAAA;EAjGJ;EAoGE;;;IAGE,aAAA;EAlGJ;AACF;AAuGA;;EAEE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AArGF;;AAyGA;EACE,kBAAA;AAtGF;AAwGE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAtGJ;AAyGE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAvGJ;AAyGI;EACE,aAAA;EACA,wCAAA;EACA,6CAAA;AAvGN;AA0GI;EACE,qBAAA;AAxGN;AA2GI;EACE,cAAA;AAzGN;AA6GE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AA3GJ;AA6GI;EACE,yBAAA;EACA,cAAA;AA3GN;AA+GE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EACA,mBAAA;EACA,gBAAA;EACA,iDAAA;AA7GJ;AA+GI;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AA7GN;AA+GM;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AA7GR;AA+GQ;EACE,yBAAA;EACA,cAAA;AA7GV;AAgHQ;EACE,2BAAA;EACA,yCAAA;EACA,yBAAA;AA9GV;AAmHI;EACE,iBAAA;EACA,gBAAA;AAjHN;AAmHM;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AAjHR;AAmHQ;EACE,mBAAA;AAjHV;AAoHQ;EACE,yBAAA;AAlHV;AAqHQ;EACE,yBAAA;AAnHV;AAqHU;EACE,yBAAA;AAnHZ;AAuHQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AArHV;AAuHU;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;AArHZ;AAwHU;EACE,kBAAA;EACA,cAAA;AAtHZ;AAyHU;EACE,kBAAA;EACA,cAAA;AAvHZ;AA4HM;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA1HR;;AAiIA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AA9HF;AAgIE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;AA9HJ;AAiIE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA/HJ;AAiII;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,wBAAA;EACA,qBAAA;AA/HN;AAmIE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAjIJ;AAmII;EACE,cAAA;EACA,mBAAA;AAjIN;;AAuIA;EACE;IACE,UAAA;IACA,2BAAA;EApIF;EAsIA;IACE,UAAA;IACA,wBAAA;EApIF;AACF;AAwIA;EACE,UAAA;AAtIF;;AAyIA;EACE,mBAAA;EACA,kBAAA;AAtIF;;AAyIA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAtIF;;AAyIA;EACE,mBAAA;AAtIF;;AAyIA,+DAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA,EAAA,8BAAA;EACA,aAAA;EACA,sBAAA;AAvIF;;AA0IA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA,EAAA,gCAAA;AAvIF;AAyIE;EACE,YAAA,EAAA,uCAAA;AAvIJ;;AA2IA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAxIF;AA0IE;EACE,cAAA;AAxIJ;AA2IE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAzIJ;AA2II;;EACE,mBAAA;EACA,YAAA;AAxIN;AA4IE;EACE,gCAAA;EACA,YAAA;AA1IJ;AA4II;EACE,uBAAA;AA1IN;AA6II;EACE,yBAAA;EACA,cAAA;AA3IN;AA+IE;EACE,mBAAA;EACA,YAAA;AA7IJ;AA+II;EACE,mBAAA;AA7IN;;AAmJA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhJF;AAkJE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAhJJ;AAmJE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AAjJJ;AAmJI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAjJN;;AAuJA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AApJF;AAsJE;EACE,cAAA;EACA,yBAAA;AApJJ","sourcesContent":["// Main Container\r\n.invoice-form-container {\r\n  min-height: calc(100vh - 118px);\r\n  background: var(--grey-shade-three);\r\n  padding: 2rem;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n  // Remove number input spinners\r\n  .no-spinner::-webkit-outer-spin-button,\r\n  .no-spinner::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n  }\r\n\r\n  // Form Content Wrapper\r\n  .invoice-form-wrapper {\r\n    background: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    padding: 1.5rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n    animation: invoice-form-fade-in 0.3s ease-out;\r\n    width: 70%;\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      width: 95%;\r\n    }\r\n  }\r\n\r\n  // Required field indicator\r\n  .invoice-form-required {\r\n    color: #ef4444;\r\n    margin-left: 0.25rem;\r\n  }\r\n\r\n  // Header styling\r\n  .invoice-form-header {\r\n    position: relative;\r\n    text-align: center;\r\n    margin-bottom: 0.5rem;\r\n\r\n    .invoice-form-title {\r\n      font-size: 1.3rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0;\r\n\r\n      @media (max-width: 768px) {\r\n        font-size: 1.25rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Divider styling\r\n  .invoice-form-divider {\r\n    border: none;\r\n    border-top: 1px solid #e5e7eb;\r\n    margin: 1.5rem 0;\r\n  }\r\n\r\n  // Form content styling\r\n  .invoice-form-content {\r\n    padding: 0;\r\n    margin: 0;\r\n    border: none;\r\n    background: transparent;\r\n  }\r\n\r\n  // Form sections\r\n  .form-section {\r\n    background: transparent;\r\n    border-radius: 0.375rem;\r\n    margin-bottom: 1.5rem;\r\n\r\n    &:last-of-type {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n\r\n      .invoice-form-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Form rows and groups\r\n  .form-row {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n\r\n  .form-group {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n\r\n      .invoice-form-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n\r\n    // Input styling\r\n    input,\r\n    select,\r\n    textarea {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n      height: 2.5rem;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:focus) {\r\n        border-color: #9ca3af;\r\n      }\r\n\r\n      &::placeholder {\r\n        color: #9ca3af;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #f9fafb;\r\n        color: #6b7280;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n    select {\r\n      appearance: none;\r\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n      background-position: right 0.5rem center;\r\n      background-repeat: no-repeat;\r\n      background-size: 1.5rem 1.5rem;\r\n      padding-right: 2.5rem;\r\n    }\r\n\r\n    textarea {\r\n      height: auto;\r\n      min-height: 4rem;\r\n      resize: vertical;\r\n      line-height: 1.5;\r\n    }\r\n\r\n    // Green amount display\r\n    .amount-display {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      height: 2.5rem;\r\n      font-weight: 600;\r\n      color: #059669;\r\n      background: #ecfdf5;\r\n      border: 1px solid #d1fae5;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      min-width: 100px;\r\n    }\r\n  }\r\n\r\n  // Added Services Cards\r\n  .added-services-container {\r\n    margin-bottom: 1.5rem;\r\n\r\n    .service-card {\r\n      background: #f8fafc;\r\n      border: 1px solid #e2e8f0;\r\n      border-radius: 8px;\r\n      margin-bottom: 1rem;\r\n      transition: all 0.2s ease;\r\n\r\n      &:hover {\r\n        border-color: #cbd5e1;\r\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n      }\r\n\r\n      .service-card-content {\r\n        padding: 1rem;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n\r\n        @media (max-width: 768px) {\r\n          flex-direction: column;\r\n          align-items: stretch;\r\n          gap: 1rem;\r\n        }\r\n      }\r\n\r\n      .service-card-main {\r\n        display: flex;\r\n        flex: 1;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n\r\n        @media (max-width: 768px) {\r\n          flex-direction: column;\r\n          align-items: stretch;\r\n          gap: 0.75rem;\r\n        }\r\n      }\r\n\r\n      .service-info {\r\n        flex: 1;\r\n\r\n        h4 {\r\n          margin: 0 0 0.25rem 0;\r\n          font-size: 1rem;\r\n          font-weight: 600;\r\n          color: #1f2937;\r\n        }\r\n\r\n        .service-description {\r\n          margin: 0;\r\n          font-size: 0.875rem;\r\n          color: #6b7280;\r\n          font-style: italic;\r\n        }\r\n      }\r\n\r\n      .service-details {\r\n        display: flex;\r\n        gap: 1rem;\r\n        align-items: center;\r\n        font-size: 0.875rem;\r\n        color: #4b5563;\r\n\r\n        @media (max-width: 768px) {\r\n          justify-content: space-between;\r\n        }\r\n\r\n        .service-amount {\r\n          font-weight: 600;\r\n          color: #059669;\r\n          font-size: 1rem;\r\n        }\r\n      }\r\n\r\n      .service-card-actions {\r\n        display: flex;\r\n        gap: 0.5rem;\r\n        margin-left: 1rem;\r\n\r\n        @media (max-width: 768px) {\r\n          margin-left: 0;\r\n          justify-content: center;\r\n        }\r\n\r\n        .edit-service-btn {\r\n          background-color: #3b82f6;\r\n          color: white;\r\n          border: none;\r\n          padding: 0.375rem 0.75rem;\r\n          border-radius: 0.25rem;\r\n          font-size: 0.75rem;\r\n          font-weight: 500;\r\n          cursor: pointer;\r\n          transition: background-color 0.2s ease;\r\n\r\n          &:hover:not(:disabled) {\r\n            background-color: #2563eb;\r\n          }\r\n\r\n          &:disabled {\r\n            background-color: #9ca3af;\r\n            cursor: not-allowed;\r\n          }\r\n        }\r\n\r\n        .delete-service-btn {\r\n          background-color: #ef4444;\r\n          color: white;\r\n          border: none;\r\n          padding: 0.375rem 0.75rem;\r\n          border-radius: 0.25rem;\r\n          font-size: 0.75rem;\r\n          font-weight: 500;\r\n          cursor: pointer;\r\n          transition: background-color 0.2s ease;\r\n\r\n          &:hover:not(:disabled) {\r\n            background-color: #dc2626;\r\n          }\r\n\r\n          &:disabled {\r\n            background-color: #9ca3af;\r\n            cursor: not-allowed;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Current Service Form\r\n  .current-service-form {\r\n    background: #ffffff;\r\n    border: 2px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    padding: 1.5rem;\r\n\r\n    .service-form-header {\r\n      margin-bottom: 1rem;\r\n\r\n      h4 {\r\n        margin: 0;\r\n        font-size: 1rem;\r\n        font-weight: 600;\r\n        color: #374151;\r\n      }\r\n    }\r\n\r\n    .service-form-row {\r\n      display: flex;\r\n      gap: 1rem;\r\n      margin-bottom: 1rem;\r\n\r\n      @media (max-width: 768px) {\r\n        flex-direction: column;\r\n        gap: 0.75rem;\r\n      }\r\n    }\r\n\r\n    .service-description-row {\r\n      margin-bottom: 1rem;\r\n\r\n      .description-group {\r\n        flex: 1;\r\n      }\r\n    }\r\n\r\n    .service-form-actions {\r\n      display: flex;\r\n      gap: 0.75rem;\r\n      justify-content: flex-end;\r\n\r\n      @media (max-width: 768px) {\r\n        flex-direction: column;\r\n      }\r\n\r\n      .add-current-service-btn {\r\n        background-color: var(--primary-color);\r\n        color: white;\r\n        border: none;\r\n        padding: 0.5rem 1rem;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: background-color 0.2s ease;\r\n\r\n        &:hover:not(:disabled) {\r\n          background-color: #2563eb;\r\n        }\r\n\r\n        &:disabled {\r\n          background-color: #9ca3af;\r\n          cursor: not-allowed;\r\n          opacity: 0.6;\r\n        }\r\n      }\r\n\r\n      .cancel-edit-btn {\r\n        background-color: #6b7280;\r\n        color: white;\r\n        border: none;\r\n        padding: 0.5rem 1rem;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        transition: background-color 0.2s ease;\r\n\r\n        &:hover {\r\n          background-color: #4b5563;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // Invoice Summary\r\n  .summary {\r\n    background: var(--grey-shade-three);\r\n    padding: 1rem;\r\n    border-radius: 0.25rem;\r\n    border: 1px solid #e5e7eb;\r\n    margin: 1rem 0 0 0;\r\n\r\n    p {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      margin: 0.5rem 0;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n\r\n      &:first-child {\r\n        margin-top: 0;\r\n      }\r\n\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n        font-size: 1rem;\r\n        font-weight: 600;\r\n        color: #059669;\r\n        border-top: 1px solid #e5e7eb;\r\n        padding-top: 0.75rem;\r\n        margin-top: 0.75rem;\r\n      }\r\n\r\n      strong {\r\n        color: #111827;\r\n        font-weight: 500;\r\n      }\r\n\r\n      span {\r\n        font-size: 0.75rem;\r\n        color: #6b7280;\r\n        font-style: italic;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Form actions\r\n  .form-actions {\r\n    display: flex;\r\n    justify-content: end;\r\n    gap: 1rem;\r\n    margin-top: 1.5rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n    }\r\n\r\n    .btn-primary {\r\n      padding: 0.75rem 1.5rem;\r\n      border-radius: 0.25rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      cursor: pointer;\r\n      border: none;\r\n      min-width: 120px;\r\n      transition: all 0.2s ease;\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n      }\r\n\r\n      &:hover:not(:disabled) {\r\n        background-color: #005a9a;\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #d1d5db;\r\n        color: #9ca3af;\r\n        opacity: 0.6;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Modal styles\r\n  .client-modal-header-inv {\r\n    .close-cross {\r\n      background: none;\r\n      border: none;\r\n      font-size: 1.5rem;\r\n      color: #6b7280;\r\n      cursor: pointer;\r\n      padding: 0;\r\n      width: 2rem;\r\n      height: 2rem;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      border-radius: 0.25rem;\r\n\r\n      &:hover {\r\n        color: #374151;\r\n        background-color: #f3f4f6;\r\n      }\r\n    }\r\n  }\r\n\r\n  .service-modal-body {\r\n    h3 {\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin: 0 0 1rem 0;\r\n      text-align: center;\r\n    }\r\n\r\n    .new-service-input {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      margin-bottom: 1rem;\r\n      box-sizing: border-box;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n    }\r\n\r\n    .btn-primary {\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n      border: none;\r\n      padding: 0.5rem 1rem;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transform: translateX(10.7rem);\r\n\r\n      &:hover {\r\n        background-color: #005a9a;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #9ca3af;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Focus visible improvements for accessibility\r\n  input:focus-visible,\r\n  select:focus-visible,\r\n  textarea:focus-visible,\r\n  button:focus-visible {\r\n    outline: 2px solid #3b82f6;\r\n    outline-offset: 2px;\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes invoice-form-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Responsive design improvements\r\n@media (max-width: 1024px) {\r\n  .invoice-form-container {\r\n    .invoice-form-wrapper {\r\n      width: 85%;\r\n    }\r\n\r\n    .form-row {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .invoice-form-container {\r\n    padding: 1rem;\r\n\r\n    .invoice-form-wrapper {\r\n      width: 95%;\r\n    }\r\n\r\n    .form-section {\r\n      padding: 1rem;\r\n    }\r\n\r\n    .invoice-form-header .invoice-form-title {\r\n      font-size: 1.25rem;\r\n    }\r\n\r\n    .form-section h3 {\r\n      font-size: 1rem;\r\n    }\r\n\r\n    .form-actions {\r\n      .btn-primary {\r\n        padding: 0.5rem 1rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .invoice-form-container {\r\n    padding: 0.5rem;\r\n\r\n    .invoice-form-wrapper {\r\n      padding: 0.75rem;\r\n      width: 100%;\r\n    }\r\n\r\n    .form-section {\r\n      padding: 0.75rem;\r\n    }\r\n\r\n    .invoice-form-header .invoice-form-title {\r\n      font-size: 1.125rem;\r\n    }\r\n\r\n    .form-group {\r\n      input,\r\n      select,\r\n      textarea {\r\n        padding: 0.375rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n\r\n      .amount-display {\r\n        font-size: 0.8125rem;\r\n        padding: 0.375rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .invoice-form-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    .invoice-form-wrapper {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    .form-section {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    .form-actions,\r\n    .service-card-actions,\r\n    .service-form-actions {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n// Case Selection Styles - Invoice Form Specific (prefixed to avoid TaskForm conflicts)\r\n.case-loading-text,\r\n.no-cases-text {\r\n  color: #6b7280;\r\n  font-size: 0.875rem;\r\n  font-style: italic;\r\n  padding: 1rem;\r\n  text-align: center;\r\n  background: #f9fafb;\r\n  border-radius: 0.375rem;\r\n  border: 1px dashed #d1d5db;\r\n}\r\n\r\n// Invoice case selector dropdown\r\n.invoice-case-selector {\r\n  position: relative;\r\n\r\n  .invoice-label-case {\r\n    display: block;\r\n    margin-bottom: 0.5rem;\r\n    font-weight: 500;\r\n    font-size: 0.875rem;\r\n    color: #374151;\r\n  }\r\n\r\n  .invoice-case-dropdown-input {\r\n    width: 100%;\r\n    padding: 0.5rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-family: inherit;\r\n    color: #374151;\r\n    background: #ffffff;\r\n    box-sizing: border-box;\r\n    height: 2.5rem;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: var(--primary-light-color);\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n\r\n    &:hover:not(:focus) {\r\n      border-color: #9ca3af;\r\n    }\r\n\r\n    &::placeholder {\r\n      color: #9ca3af;\r\n    }\r\n  }\r\n\r\n  .clear-case-button {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: transparent;\r\n    border: none;\r\n    color: #6b7280;\r\n    font-size: 24px;\r\n    cursor: pointer;\r\n    padding: 0;\r\n    width: 24px;\r\n    height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    transition: all 0.2s ease;\r\n    z-index: 1;\r\n\r\n    &:hover {\r\n      background-color: #f3f4f6;\r\n      color: #374151;\r\n    }\r\n  }\r\n\r\n  .invoice-dropdown-content {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    width: 100%;\r\n    background: #ffffff;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 0.375rem;\r\n    z-index: 1000;\r\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n    margin-top: 0.25rem;\r\n    overflow: hidden;\r\n    animation: invoice-dropdown-fade-in 0.2s ease-out;\r\n\r\n    .invoice-dropdown-tabs {\r\n      display: flex;\r\n      background: #f9fafb;\r\n      border-bottom: 1px solid #e5e7eb;\r\n\r\n      button {\r\n        flex: 1;\r\n        padding: 0.75rem 1rem;\r\n        border: none;\r\n        background: transparent;\r\n        color: #6b7280;\r\n        font-weight: 500;\r\n        font-size: 0.875rem;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n        border-bottom: 2px solid transparent;\r\n\r\n        &:hover {\r\n          background-color: #f3f4f6;\r\n          color: #374151;\r\n        }\r\n\r\n        &.active {\r\n          color: var(--primary-color);\r\n          border-bottom-color: var(--primary-color);\r\n          background-color: #ffffff;\r\n        }\r\n      }\r\n    }\r\n\r\n    .invoice-dropdown-options {\r\n      max-height: 250px;\r\n      overflow-y: auto;\r\n\r\n      .invoice-dropdown-option {\r\n        padding: 0.75rem 1rem;\r\n        cursor: pointer;\r\n        border-bottom: 1px solid #f3f4f6;\r\n        transition: all 0.2s ease;\r\n\r\n        &:last-child {\r\n          border-bottom: none;\r\n        }\r\n\r\n        &:hover {\r\n          background-color: #f9fafb;\r\n        }\r\n\r\n        &.selected {\r\n          background-color: #eff6ff;\r\n\r\n          &:hover {\r\n            background-color: #dbeafe;\r\n          }\r\n        }\r\n\r\n        .invoice-case-info {\r\n          display: flex;\r\n          flex-direction: column;\r\n          gap: 0.25rem;\r\n\r\n          .invoice-case-parties {\r\n            font-weight: 600;\r\n            font-size: 0.875rem;\r\n            color: #1f2937;\r\n          }\r\n\r\n          .invoice-case-ref {\r\n            font-size: 0.75rem;\r\n            color: #6b7280;\r\n          }\r\n\r\n          .invoice-case-number {\r\n            font-size: 0.75rem;\r\n            color: #9ca3af;\r\n          }\r\n        }\r\n      }\r\n\r\n      .invoice-no-data {\r\n        padding: 1rem;\r\n        text-align: center;\r\n        color: #6b7280;\r\n        font-size: 0.875rem;\r\n        font-style: italic;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Invoice selected case display\r\n.invoice-selected-case-display {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-top: 0.75rem;\r\n  padding: 0.75rem 1rem;\r\n  background: #eff6ff;\r\n  border: 1px solid #dbeafe;\r\n  border-radius: 0.375rem;\r\n\r\n  .invoice-selected-case-label {\r\n    font-size: 0.75rem;\r\n    font-weight: 500;\r\n    color: #6b7280;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.025em;\r\n  }\r\n\r\n  .invoice-selected-case-value {\r\n    flex: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    font-weight: 600;\r\n    font-size: 0.875rem;\r\n    color: #1f2937;\r\n\r\n    .invoice-court-type-badge {\r\n      font-size: 0.75rem;\r\n      font-weight: 500;\r\n      color: #ffffff;\r\n      background: var(--primary-color);\r\n      padding: 0.125rem 0.5rem;\r\n      border-radius: 9999px;\r\n    }\r\n  }\r\n\r\n  .invoice-clear-case-btn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: none;\r\n    border: none;\r\n    padding: 0;\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    font-size: 1.25rem;\r\n    color: #9ca3af;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    transition: all 0.15s ease;\r\n\r\n    &:hover {\r\n      color: #ef4444;\r\n      background: #fef2f2;\r\n    }\r\n  }\r\n}\r\n\r\n// Invoice dropdown animation\r\n@keyframes invoice-dropdown-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Scrollbar styling for invoice dropdown\r\n.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options::-webkit-scrollbar-track {\r\n  background: #f1f5f9;\r\n  border-radius: 3px;\r\n}\r\n\r\n.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options::-webkit-scrollbar-thumb {\r\n  background: #cbd5e1;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.invoice-case-selector .invoice-dropdown-content .invoice-dropdown-options::-webkit-scrollbar-thumb:hover {\r\n  background: #94a3b8;\r\n}\r\n\r\n/* MODIFICATION: ADDED STYLES FOR THE NEW \"ADD SERVICE\" MODAL */\r\n\r\n.confirmation-modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1050; /* Higher z-index for modals */\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.confirmation-modal {\r\n  background: #ffffff;\r\n  padding: 24px;\r\n  border-radius: 8px;\r\n  max-width: 95%;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  border: 1px solid #e5e7eb;\r\n  position: relative;\r\n  animation: invoice-form-fade-in 0.2s ease-out; /* Re-using existing animation */\r\n\r\n  &.notinvoice {\r\n    width: 420px; /* Specific width for the small modal */\r\n  }\r\n}\r\n\r\n.confirmation-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n\r\n  &.notinvoice {\r\n    padding-top: 0;\r\n  }\r\n\r\n  .confirm-btn,\r\n  .cancel-btn {\r\n    padding: 8px 18px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    min-width: 80px;\r\n\r\n    &:disabled {\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n\r\n  .confirm-btn {\r\n    background: var(--primary-color);\r\n    color: white;\r\n\r\n    &:hover:not(:disabled) {\r\n      filter: brightness(95%);\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: #d1d5db;\r\n      color: #9ca3af;\r\n    }\r\n  }\r\n\r\n  .cancel-btn {\r\n    background: #6b7280;\r\n    color: white;\r\n\r\n    &:hover:not(:disabled) {\r\n      background: #4b5563;\r\n    }\r\n  }\r\n}\r\n\r\n// Styles for the content within the new modal\r\n.add-new-field-modal-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n\r\n  h3 {\r\n    font-size: 1.25rem;\r\n    font-weight: 600;\r\n    color: #1f2937;\r\n    margin: 0;\r\n    text-align: left;\r\n    border-bottom: none;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .add-new-field-input {\r\n    width: 100%;\r\n    padding: 10px 12px;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    box-sizing: border-box;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #3b82f6;\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n    }\r\n  }\r\n}\r\n\r\n// Ensure close button inside the new modal is styled correctly\r\n.confirmation-modal .close-cross {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  color: #6b7280;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 0.25rem;\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n\r\n  &:hover {\r\n    color: #374151;\r\n    background-color: #f3f4f6;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
